import CircleArea from "./circle";
import strFunc from "@/lib/lyg/string";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function TopInfoArea(props: any) {
  let myProps = {
    info: {},
    td_sort_data_arr: [],
    subject_name: "",
    Style: {},
    sub_title_text:"",
    is_show_stu_total_code:false,
    openTodoDaySort: (inData: any) => { },
    show_detail_user_by_seq: (inData: any) => { },
    on_click_sub_title: () => { },
    ...props
  };
  let Style = myProps.Style;
  let info = myProps.info;
  let subject_name=myProps.subject_name;

  const get_average_per_by_data = () => {
    let aver_per = 0;
    let per_sum_num = 0;
    let per_sum_count = 0;;
    for (let i = 0; i < myProps.td_sort_data_arr.length; i++) {
      if (myProps.td_sort_data_arr[i]["sort"] == "pre_homework") {
        continue;
      }
      let td_sort_row=myProps.td_sort_data_arr[i];
      let row_per_num=0;
      if(strFunc.is_empty(subject_name)){
        row_per_num = parseInt(strFunc.uncomma(td_sort_row["percent"]));
      }else{
        if(td_sort_row["subject_data_json"][subject_name]){
          row_per_num = parseInt(strFunc.uncomma(td_sort_row["subject_data_json"][subject_name]["percent"]));
        }
      }
      
      per_sum_num += row_per_num;
      per_sum_count++;
    }
    if (per_sum_count != 0 && per_sum_num != 0) {
      aver_per = Math.floor(per_sum_num / per_sum_count);
    }
    return aver_per;
  };
  let aver_per = get_average_per_by_data();

  const get_color_style_of_sum_tag = (percent: number) => {
    let color = "#F48282";
    if (percent == 0) {
      color = "#F48282";
    } else if (percent > 0) {
      color = "#EBBD70";
    }
    if (percent >= 100) {
      color = "#B7C528";
    }
    return color;
  };
  let per_color = get_color_style_of_sum_tag(aver_per);

  let a_stu_grade_str = info.a_stu_grade;
  let select_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade' });
  for (let i = 0; i < select_option_arr.length; i++) {
    if (select_option_arr[i]["value"] == a_stu_grade_str) {
      a_stu_grade_str = select_option_arr[i]["text"];
    }
  }

  let stu_total_code=info.a_stu_total_code;
  if(myProps.is_show_stu_total_code!=true){
    stu_total_code="";
  }

  return (
    <div className={Style.card_box_top_wrap}>
      <div 
        className={Style.card_box_top_per_wrap}
        onClick={() => {
        myProps.openTodoDaySort({
          select_stu_name: info.a_user_name,
          select_stu_seq: info.a_seq,
          subject_name: subject_name,
        });
      }} style={{cursor:"pointer"}}>
        <CircleArea
          per_num={aver_per>100?100:aver_per}
          color={per_color}
          Style={Style}
          with={50}
          height={50}
        ></CircleArea>
        <div className={Style.card_box_top_per_text} style={{ color: per_color }}>
          {aver_per}%
        </div>
      </div>
      <div className={Style.card_box_top_title} >
        <div 
          onClick={() => {
            myProps.show_detail_user_by_seq(info.a_seq);
          }}
          style={{fontSize:"16px",cursor:"pointer"}} title={info.a_user_name+" "+info["a_school_name"]+" "+a_stu_grade_str}>
          {info.a_user_name}
          {stu_total_code&&
            <span className="ml-1" style={{fontSize:"12px",color:"#3FAC96"}}>{stu_total_code}</span>
          }
          <span className="ml-1" style={{fontSize:"14px",color:"#666"}}>
            {a_stu_grade_str}
          </span>
        </div>
        <div style={{color:"#666",cursor:"pointer"}} 
          onClick={()=>{myProps.on_click_sub_title();}} >
          {myProps.sub_title_text}
        </div>
      </div>
    </div>
  );
}
export default TopInfoArea;